module.exports = __webpack_public_path__ + "img/01125797003301.de3a85fa.png";